module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6AYig"))).then(() => parcelRequire('8rm4T'));